import type { BillingPaymentStatus } from '@practium/features/api';
import styles from './BillingStatusBadge.module.css';

const STATUS_LABELS: Record<BillingPaymentStatus, string> = {
	paid: 'Faturado',
	canceled: 'Cancelado',
	processing: 'Processando',
	failed: 'Falhou',
	refunded: 'Reembolsado',
};

interface BillingStatusBadgeProps {
	status: BillingPaymentStatus;
}

export const BillingStatusBadge = ({ status }: BillingStatusBadgeProps) => {
	const statusClass = styles[status] ?? styles.processing;
	return (
		<span className={`${styles.badge} ${statusClass}`}>{STATUS_LABELS[status] ?? status}</span>
	);
};
